/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type APPROVAL_STATUS = "APPROVED" | "NOT_SUBMITTED" | "SUBMITTED" | "%future added value";
export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type CreateTimeRegInput = {
    taskId?: string | null | undefined;
    idleTimeId?: string | null | undefined;
    projectId?: string | null | undefined;
    year?: number | null | undefined;
    month?: number | null | undefined;
    day?: number | null | undefined;
    minutesRegistered?: number | null | undefined;
    billableMinutesRegistered?: number | null | undefined;
    harvestTaskId?: string | null | undefined;
    unit4ActivityId?: string | null | undefined;
    unit4ActivityName?: string | null | undefined;
    personId?: string | null | undefined;
    roleId?: string | null | undefined;
    billable?: boolean | null | undefined;
    notes?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createTimeRegistrationMutationModernMutationVariables = {
    input: CreateTimeRegInput;
    fetchCustomFields: boolean;
};
export type createTimeRegistrationMutationModernMutationResponse = {
    readonly createTimeReg: {
        readonly timeReg: {
            readonly node: {
                readonly id: string;
                readonly invoiced: boolean | null;
                readonly xeroInvoiceId: string | null;
                readonly lockedInPeriod: boolean | null;
                readonly year: number | null;
                readonly month: number | null;
                readonly day: number | null;
                readonly updatedAt: string | null;
                readonly canvasTimelineDate: number | null;
                readonly minutesRegistered: number | null;
                readonly billableMinutesRegistered: number | null;
                readonly allocationId: string | null;
                readonly notes: string | null;
                readonly price: number | null;
                readonly unit4ActivityId: string | null;
                readonly unit4ActivityName: string | null;
                readonly harvestTaskIdInt: number | null;
                readonly harvestTask: {
                    readonly name: string | null;
                } | null;
                readonly harvestTimeId: number | null;
                readonly approvalStatus: APPROVAL_STATUS | null;
                readonly person: {
                    readonly id: string;
                    readonly fullName: string | null;
                    readonly isViewer: boolean | null;
                    readonly firstName: string | null;
                    readonly lastName: string | null;
                    readonly profilePictureId: string | null;
                    readonly profilePictureDefaultId: number | null;
                    readonly role: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                } | null;
                readonly task: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly progress: number | null;
                    readonly companyTaskId: number | null;
                    readonly highPriority: boolean | null;
                    readonly approved: boolean | null;
                    readonly favoured: boolean | null;
                    readonly fullAccessToProject: boolean | null;
                    readonly latestUiUpdateAt: string | null;
                    readonly timeLeft: number | null;
                    readonly timeLeftMinutesWithoutFutureTimeRegs: number | null;
                    readonly totalMinutesRegistered: number | null;
                    readonly currentPrice: number | null;
                    readonly allTotalTimeAndExpensesAtCompletion: number | null;
                    readonly assignedPersons: ReadonlyArray<{
                        readonly id: string;
                    } | null> | null;
                    readonly project: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly status: PROJECT_STATUS | null;
                        readonly companyProjectId: number | null;
                        readonly projectColor: string | null;
                        readonly estimationUnit: string | null;
                        readonly fullAccessToProject: boolean | null;
                        readonly client: {
                            readonly id: string;
                            readonly name: string | null;
                        } | null;
                        readonly harvestProject: {
                            readonly id: string;
                            readonly name: string | null;
                        } | null;
                    } | null;
                    readonly phase: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                } | null;
                readonly project: {
                    readonly id: string;
                    readonly projectPersons: {
                        readonly edges: ReadonlyArray<{
                            readonly node: {
                                readonly person: {
                                    readonly id: string;
                                    readonly fullName: string | null;
                                    readonly profilePictureId: string | null;
                                } | null;
                            } | null;
                        } | null> | null;
                    } | null;
                } | null;
                readonly idleTime: {
                    readonly id: string;
                } | null;
                readonly role: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
                readonly customFields: {
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly key: string;
                            readonly displayName: string;
                            readonly value: string | null;
                            readonly readOnly?: boolean | undefined;
                        } | null;
                    } | null> | null;
                } | null;
            } | null;
        } | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type createTimeRegistrationMutationModernMutation = {
    readonly response: createTimeRegistrationMutationModernMutationResponse;
    readonly variables: createTimeRegistrationMutationModernMutationVariables;
};



/*
mutation createTimeRegistrationMutationModernMutation(
  $input: CreateTimeRegInput!
  $fetchCustomFields: Boolean!
) {
  createTimeReg(input: $input) {
    timeReg {
      node {
        id
        invoiced
        xeroInvoiceId
        lockedInPeriod
        year
        month
        day
        updatedAt
        canvasTimelineDate
        minutesRegistered
        billableMinutesRegistered
        allocationId
        notes
        price
        unit4ActivityId
        unit4ActivityName
        harvestTaskIdInt
        harvestTask {
          name
          id
        }
        harvestTimeId
        approvalStatus
        person {
          id
          fullName
          isViewer
          firstName
          lastName
          profilePictureId
          profilePictureDefaultId
          role {
            id
            name
          }
        }
        task {
          id
          name
          progress
          companyTaskId
          highPriority
          approved
          favoured
          fullAccessToProject
          latestUiUpdateAt
          timeLeft
          timeLeftMinutesWithoutFutureTimeRegs
          totalMinutesRegistered
          currentPrice
          allTotalTimeAndExpensesAtCompletion
          assignedPersons {
            id
          }
          project {
            id
            name
            status
            companyProjectId
            projectColor
            estimationUnit
            fullAccessToProject
            client {
              id
              name
            }
            harvestProject {
              id
              name
            }
          }
          phase {
            id
            name
          }
        }
        project {
          id
          projectPersons(first: 100, contactsOnly: true) {
            edges {
              node {
                person {
                  id
                  fullName
                  profilePictureId
                }
                id
              }
            }
          }
        }
        idleTime {
          id
        }
        role {
          id
          name
        }
        customFields(first: 1000, fetchCustomFields: $fetchCustomFields) {
          edges {
            node {
              key
              displayName
              value
              ... on TextCustomFieldValue {
                readOnly
              }
              id
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateTimeRegInput!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchCustomFields",
    "type": "Boolean!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "xeroInvoiceId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedInPeriod",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canvasTimelineDate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesRegistered",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableMinutesRegistered",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allocationId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4ActivityId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4ActivityName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "harvestTaskIdInt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "harvestTimeId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvalStatus",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v24 = [
  (v2/*: any*/),
  (v19/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isViewer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureDefaultId",
      "storageKey": null
    },
    (v25/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v28 = [
  (v2/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "highPriority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "favoured",
      "storageKey": null
    },
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latestUiUpdateAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeLeft",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeLeftMinutesWithoutFutureTimeRegs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalMinutesRegistered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allTotalTimeAndExpensesAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "assignedPersons",
      "plural": true,
      "selections": (v28/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v19/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimationUnit",
          "storageKey": null
        },
        (v27/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "client",
          "plural": false,
          "selections": (v24/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HarvestProjectType",
          "kind": "LinkedField",
          "name": "harvestProject",
          "plural": false,
          "selections": (v24/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseType",
      "kind": "LinkedField",
      "name": "phase",
      "plural": false,
      "selections": (v24/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = [
  {
    "kind": "Literal",
    "name": "contactsOnly",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "IdleTime",
  "kind": "LinkedField",
  "name": "idleTime",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v33 = {
  "kind": "Variable",
  "name": "fetchCustomFields",
  "variableName": "fetchCustomFields"
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readOnly",
      "storageKey": null
    }
  ],
  "type": "TextCustomFieldValue"
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v42 = [
  (v33/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createTimeRegistrationMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateTimeRegPayload",
        "kind": "LinkedField",
        "name": "createTimeReg",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TimeRegTypeEdge",
            "kind": "LinkedField",
            "name": "timeReg",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeRegType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HarvestTaskType",
                    "kind": "LinkedField",
                    "name": "harvestTask",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v26/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": (v30/*: any*/),
                        "concreteType": "ProjectPersonTypeConnection",
                        "kind": "LinkedField",
                        "name": "projectPersons",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectPersonTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectPerson",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "projectPersons(contactsOnly:true,first:100)"
                      }
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": "customFields",
                    "args": [
                      (v33/*: any*/)
                    ],
                    "concreteType": "CustomFieldValueV2TypeConnection",
                    "kind": "LinkedField",
                    "name": "__TimeRegistrations_customFields_connection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomFieldValueV2TypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v39/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v40/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v41/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createTimeRegistrationMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateTimeRegPayload",
        "kind": "LinkedField",
        "name": "createTimeReg",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TimeRegTypeEdge",
            "kind": "LinkedField",
            "name": "timeReg",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeRegType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HarvestTaskType",
                    "kind": "LinkedField",
                    "name": "harvestTask",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v26/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": (v30/*: any*/),
                        "concreteType": "ProjectPersonTypeConnection",
                        "kind": "LinkedField",
                        "name": "projectPersons",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectPersonTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectPerson",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "projectPersons(contactsOnly:true,first:100)"
                      }
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": (v42/*: any*/),
                    "concreteType": "CustomFieldValueV2TypeConnection",
                    "kind": "LinkedField",
                    "name": "customFields",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomFieldValueV2TypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v2/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v39/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v40/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v42/*: any*/),
                    "filters": [
                      "fetchCustomFields"
                    ],
                    "handle": "connection",
                    "key": "TimeRegistrations_customFields",
                    "kind": "LinkedHandle",
                    "name": "customFields"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v41/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "createTimeReg",
            "timeReg",
            "node",
            "customFields"
          ]
        }
      ]
    },
    "name": "createTimeRegistrationMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation createTimeRegistrationMutationModernMutation(\n  $input: CreateTimeRegInput!\n  $fetchCustomFields: Boolean!\n) {\n  createTimeReg(input: $input) {\n    timeReg {\n      node {\n        id\n        invoiced\n        xeroInvoiceId\n        lockedInPeriod\n        year\n        month\n        day\n        updatedAt\n        canvasTimelineDate\n        minutesRegistered\n        billableMinutesRegistered\n        allocationId\n        notes\n        price\n        unit4ActivityId\n        unit4ActivityName\n        harvestTaskIdInt\n        harvestTask {\n          name\n          id\n        }\n        harvestTimeId\n        approvalStatus\n        person {\n          id\n          fullName\n          isViewer\n          firstName\n          lastName\n          profilePictureId\n          profilePictureDefaultId\n          role {\n            id\n            name\n          }\n        }\n        task {\n          id\n          name\n          progress\n          companyTaskId\n          highPriority\n          approved\n          favoured\n          fullAccessToProject\n          latestUiUpdateAt\n          timeLeft\n          timeLeftMinutesWithoutFutureTimeRegs\n          totalMinutesRegistered\n          currentPrice\n          allTotalTimeAndExpensesAtCompletion\n          assignedPersons {\n            id\n          }\n          project {\n            id\n            name\n            status\n            companyProjectId\n            projectColor\n            estimationUnit\n            fullAccessToProject\n            client {\n              id\n              name\n            }\n            harvestProject {\n              id\n              name\n            }\n          }\n          phase {\n            id\n            name\n          }\n        }\n        project {\n          id\n          projectPersons(first: 100, contactsOnly: true) {\n            edges {\n              node {\n                person {\n                  id\n                  fullName\n                  profilePictureId\n                }\n                id\n              }\n            }\n          }\n        }\n        idleTime {\n          id\n        }\n        role {\n          id\n          name\n        }\n        customFields(first: 1000, fetchCustomFields: $fetchCustomFields) {\n          edges {\n            node {\n              key\n              displayName\n              value\n              ... on TextCustomFieldValue {\n                readOnly\n              }\n              id\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b4ccd9aa31f2746008411b172b0ded39';
export default node;
